import { NGROK } from "../../../../APIs";
import { apiClient } from "../../../../utils/apiClient";
import { Device } from "../../interfaces/EndpointInterfaces";


export const fetchAllComputers = async (tenantName: string): Promise<any[]> => {
    const url = `${NGROK}/api/${tenantName}/computers`;
    const data = await apiClient({
        method: "GET",
        url,
    });

    return data || [];
};

export const fetchGatewayDevices = async (tenantName: string, deviceId: string): Promise<any[]> => {
    const url = `${NGROK}/api/gateway-devices?tenantName=${tenantName}&computerId=${deviceId}`;
    const data = await apiClient({
        method: "GET",
        url,
    });

    return data || [];
};